<template>
    <div class="mall-management-container">
      <!-- 搜索区域 -->
      <div class="search-card">
        <a-form layout="inline" :model="searchInput">
          <a-form-item label="名称">
            <a-input 
              v-model="searchInput.name" 
              placeholder="名称" 
              allow-clear
              style="width: 240px"
            />
          </a-form-item>
          <a-form-item>
            <a-space>
              <a-button type="primary" @click="handleSearch">
                <template #icon><icon-search /></template>
                查询
              </a-button>
              <a-button @click="resetForm">
                <template #icon><icon-refresh /></template>
                重置
              </a-button>
            </a-space>
          </a-form-item>
        </a-form>
      </div>
  
      <!-- 表格区域 -->
      <div class="table-card">
        <a-table 
          :columns="columns" 
          :data="goodsList" 
          :pagination="false" 
          :loading="loading"
          :bordered="false"
        >
          <template #operate="{ record }">
            <a-button type="text" size="small" @click="downloadFile(record.path)" :disabled="record.state == 1 || record.state == 3">
              <icon-download />
              下载
            </a-button>
          </template>
        </a-table>
  
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <a-pagination
            v-model:current="paging.page"
            v-model:page-size="paging.limit"
            :total="total"
            show-total
            show-jumper
            @change="handlePageChange"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { list_export as list } from '@/api/mall'
  import OSSUploader from '@/utils/ossClient'
  const ossClient = OSSUploader.initClient()

  const goodsList = ref([])
  const total = ref(0)
  const loading = ref(true)
  
  const searchInput = reactive({
    name: ''
  })
  
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '名称',
      dataIndex: 'name',
    },
    {
      title: '状态',
      dataIndex: 'state_text',
      width: 120,
    },
    {
      title: '路径',
      dataIndex: 'url',
      width: 120,
      ellipsis:true,
      tooltip:true,
    },
    {
      title: '导出时间',
      dataIndex: 'start_at',
      width: 200
    },
    {
      title: '生成时间',
      dataIndex: 'end_at',
      width: 200
    },
    {
      title: '操作',
      width: 180,
      slotName: 'operate',
      align:'center',
    },
  ]
  
  const paging = reactive({
    page: 1,
    limit: 10,
    status: '1'
  })
  
  const activeSearch = reactive({})
  
  onMounted(() => {
    getList()
  })
  
  const handleSearch = () => {
    Object.assign(activeSearch, searchInput)
    paging.page = 1
    getList()
  }
  
  const resetForm = () => {
    searchInput.order_no = ''
    handleSearch()
  }
  
  const getList = async () => {
    loading.value = true
    try {
      const params = {
        ...paging,
        search: activeSearch
      }
      const res = await list(params)
      goodsList.value = res.data.list
      total.value = res.data.total
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }
  
  const handlePageChange = (page) => {
    paging.page = page
    getList()
  }
  
  const downloadFile  = async (url) => {
    // 实际传 OSS
    const result = await OSSUploader.getOssDownloadUrl(ossClient, url);
     // 创建临时链接兼容 IE
    const link = document.createElement('a');
    link.href = result;
    link.setAttribute('download', ''); // 强制下载
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  </script>